import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-currconversion',
  templateUrl: './currconversion.component.html',
  styleUrls: ['./currconversion.component.scss']
})
export class CurrconversionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
